import { ODataHeader, ODataString } from "pbas-vue-components";

const WelcomKitsHeaders = [
  new ODataHeader({
    title: "globals.language",
    type: new ODataString("Language"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "Id",
    type: new ODataString("Id"),
    visible: false,
    searchable: false,
    isIdentifier: true,
    allowVisibilityChange: false,
  }),
  new ODataHeader({
    title: "PlanId",
    type: new ODataString("PlanId"),
    visible: false,
    searchable: false,
    isIdentifier: true,
    allowVisibilityChange: false,
  }),
  new ODataHeader({
    type: new ODataString("Html"),
    sortable: false,
    visible: false,
    searchable: false,
    allowVisibilityChange: false,
  }),
  new ODataHeader({
    type: new ODataString("Subject"),
    sortable: false,
    visible: false,
    searchable: false,
    allowVisibilityChange: false,
  }),
  new ODataHeader({
    type: new ODataString("KeyValueJson"),
    sortable: false,
    visible: false,
    searchable: false,
    allowVisibilityChange: false,
  }),
];
export default WelcomKitsHeaders;
